import { LoadingIndicator } from '@petsmart-ui/sparky';

export const CalculatingStatus = () => {
    return (
        <div
            className="frequency-calculator-drawer__result frequency-calculator-drawer__result--loading"
            data-testid="frequency-calculator-result-loading"
        >
            <LoadingIndicator iconSize="sm" className="frequency-calculator-drawer__result-loading-indicator" />
        </div>
    );
};
